import { omitDeep } from "./omitDeep.js";
export function stripTypename(value, options) {
    return omitDeep(value, '__typename', options);
}
stripTypename.BREAK = omitDeep.BREAK;
//# sourceMappingURL=stripTypename.js.map